import React from "react";
import { Icon } from "antd";
import styles from "./filterGroupAccordion.scss";

// Merge controls of any unnamed groups (index > 0, no `name` in config) into
// the first group. The result keeps the first group, drops the unnamed
// continuation groups, and renders any subsequent named groups as-is.
// Returns the original array reference when nothing changes so callers can
// rely on stable identity.
export const mergeUnnamedIntoFirst = (groupConfigs) => {
  if (!groupConfigs || groupConfigs.length < 2) return groupConfigs;
  var hasUnnamedAfterFirst = false;
  for (var i = 1; i < groupConfigs.length; i++) {
    var g = groupConfigs[i];
    if (g && !g.name) {
      hasUnnamedAfterFirst = true;
      break;
    }
  }
  if (!hasUnnamedAfterFirst) return groupConfigs;
  var first = groupConfigs[0];
  var mergedControls = first && first.controls ? first.controls.slice() : [];
  var restNamed = [];
  for (var j = 1; j < groupConfigs.length; j++) {
    var gj = groupConfigs[j];
    if (gj && !gj.name) {
      if (gj.controls) mergedControls = mergedControls.concat(gj.controls);
    } else {
      restNamed.push(gj);
    }
  }
  return [Object.assign({}, first, { controls: mergedControls })].concat(restNamed);
};

// Whether a parsed URL filter value is non-empty. search.ducks parses URL
// query params into `controlConfig.data` for each control before render,
// so this is the source-of-truth for "is this filter active".
const hasValueLiteral = (v) => {
  if (v === undefined || v === null || v === "") return false;
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "object") return Object.keys(v).length > 0;
  return true;
};

const controlHasValue = (node) => {
  if (!node) return false;
  if (hasValueLiteral(node.data)) return true;
  if (node.child && controlHasValue(node.child)) return true;
  return false;
};

// True if any control in the group has a non-empty value parsed from the
// URL filters. Used to auto-expand groups with applied filters when the
// detailed-search panel first opens. Reads `controlConfig.data` directly
// because the antd form keys controls by generated UUID, not by the
// config's `field` name, so `form.getFieldValue(field)` would miss values.
export const hasActiveValue = (controls) => {
  if (!controls) return false;
  return controls.some(controlHasValue);
};

const FilterGroupAccordion = props => {
  const {
    name,
    isOpen,
    onToggle,
    children,
    className,
    headerClassName,
    titleClassName
  } = props;

  return (
    <div className={`${styles.accordion} ${className || ""}`}>
      <div
        className={`${styles.header} ${headerClassName || ""}`}
        onClick={onToggle}
      >
        <span className={titleClassName || styles.title}>{name}</span>
        <Icon
          type={isOpen ? "up" : "down"}
          className={styles.chevron}
        />
      </div>
      {isOpen && <div className={styles.body}>{children}</div>}
    </div>
  );
};

export default FilterGroupAccordion;



// WEBPACK FOOTER //
// ./src/components/SearchControls/SearchGroups/FilterGroupAccordion/index.tsx